// Situation helper tabs on the homepage, with arrow key navigation between tabs
window.situationTabs = function (initial) {
    return {
        active: initial,
        select(id) {
            this.active = id;
        },
        move(event, direction) {
            const tabs = [...this.$refs.tablist.querySelectorAll('[role="tab"]')];
            const index = tabs.indexOf(event.currentTarget);
            const next = tabs[(index + direction + tabs.length) % tabs.length];
            this.select(next.dataset.situation);
            next.focus();
        },
        apply(services) {
            window.dispatchEvent(new CustomEvent('quote-preselect', { detail: { services } }));
        },
    };
}
